import type { App, ComponentPublicInstance } from 'vue';

// `__name` is Vue's internal filename-derived name (injected by @vitejs/plugin-vue for
// `<script setup>` SFCs); it is absent from the public component-options types.
type NamedComponentOptions = { name?: string; __name?: string };

export const DATA_COMPONENT_ATTR = 'data-component';

export const testMarkupMixin = {
  mounted(this: ComponentPublicInstance) {
    const el = this.$el;
    // Fragment / multi-root components expose a Text/Comment anchor as `$el` (no setAttribute);
    // skip them rather than crash. `hasAttribute` keeps the inner-most component's name and
    // preserves any explicitly-authored attribute.
    if (!(el instanceof Element) || el.hasAttribute(DATA_COMPONENT_ATTR)) {
      return;
    }

    const { name, __name } = this.$options as NamedComponentOptions;
    const componentName = name ?? __name;
    if (componentName) {
      el.setAttribute(DATA_COMPONENT_ATTR, componentName);
    }
  },
};

const registerTestMarkup = (app: App): void => {
  app.mixin(testMarkupMixin);
};

export default registerTestMarkup;
